@if (info !== null) {
<p>info</p>
<div (mouseenter)="showAdditional()" (mouseleave)="hideAdditional()" [loaderId]="loaderId" ngxUiLoaderBlurred>
  <button [ngClass]="infoClass" class="availability-info-panel" mat-raised-button>
    @if (info?.feasible) {
    <div class="rank-number">
      {{ info?.rank }}@if (info?.best === true) {
      <i class="fas fa-heart background-icon"></i>
      }
    </div>
    }
    <div class="availability-content" [class.bottom-text]="info?.feasible">
      @if (!info?.feasible) {
      Not feasible
      }
      @if (info?.feasible && !info?.score) {
      No Availability
      }
      @if (info?.feasible && outOfReservation) {
      Over Reservation
      }
    </div>
  </button>
</div>
}
@if (info === null) {
<div>
  <div>
    <ngx-ui-loader [loaderId]="loaderId" bgsPosition="center-center" fgsPosition="center-center"
      fgsType="ball-scale-multiple" overlayColor="#ffffff"></ngx-ui-loader>
  </div>
  <div class="availability-info-panel" mat-raised-button></div> -
</div>
}

@if (info !== null && showAdditionalDetail) {
<div class="icon-bar">
  <div class="icon-container">
    <i class="fa fa-truck"></i>
    @if (travelTime > 0) {
    <i class="fa fa-arrow-up"></i>
    }
    @if (travelTime === 0) {
    <i class="fa b-fa-equals"></i>
    }
    @if (travelTime < 0) { <i class="fa fa-arrow-down"></i>
      }
      {{ travelTime === 0 ? 'No change' : roundMins(travelTime) + ' mins' }} Travel Time
  </div>
  <div class="icon-container">
    <i class="fa b-fa-hourglass-half"></i>
    @if (idleTime > 0) {
    <i class="fa fa-arrow-up"></i>
    }
    @if (idleTime === 0) {
    <i class="fa b-fa-equals"></i>
    }
    @if (idleTime < 0) { <i class="fa fa-arrow-down"></i>
      }
      {{ idleTime === 0 ? 'No change' : roundMins(idleTime) + ' mins' }} Waiting Time
  </div>
  <div class="icon-container">
    <i class="fa fa-truck fa-flip-horizontal"></i>
    @if (endOfShiftTravelTime > 0) {
    <i class="fa fa-arrow-up"></i>
    }
    @if (endOfShiftTravelTime === 0) {
    <i class="fa b-fa-equals"></i>
    }
    @if (endOfShiftTravelTime < 0) { <i class="fa fa-arrow-down"></i>
      }
      {{ endOfShiftTravelTime === 0 ? 'No change' : roundMins(endOfShiftTravelTime) + ' mins' }} Return to Base Time
  </div>
</div>
}